// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const constants = {
    footer: {
        offsetTop: 48,
    },
    searchInput: {
        breakpoints: {
            lg: 1280,
        },
    },
    cartLine: {
        breakpoints: {
            md: 1200,
            xs: "xs",
        },
    },
    productList: {
        xSortAndFilter: {
            screen: "isTabletScreen",
            breakpoint: "md",
        },
    },
    navigationDrawer: {
        breakpoints: {
            md: 767,
        },
    },
    locationSearchForm: {
        breakpoints: {
            xs: 370,
        },
    },
    productGridView: {
        desktop: {
            width: 308,
            height: 308,
        },
        tablet: {
            width: 230,
            height: 230,
        },
        mobile: {
            width: 292,
            height: 292,
        },
    },
};

export const EMPTY_VALUE = "- -";
export const DivWrapper = `div[class^="Wrapper"]`;
export const ErrorApiDefaultMessage = "Please try again and contact support if you continue to have issues.";
export const XNGAGE_CUSTOM = "Xngage Custom" as any;

export const SLIDES_PER_VIEW_POINTS = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
};

export const FULFILLMENT_METHODS = {
    PickUp: "pickup",
    Ship: "ship",
    Counter: "counter",
};

export const USER_ROLES = {
    Administrator: "Administrator",
    Buyer3: "Buyer3",
};
